import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewContainerRef, ViewEncapsulation } from '@angular/core';

import { BooleanConverter } from '../../../inputConverter';
import { ImportService } from '../../../services/import.service';
import { IMCMapView } from '../../../types';
import { BaseComponent } from '../../base.component';

@Component({
    encapsulation: ViewEncapsulation.ShadowDom,
    selector: 'mc-import-shapefile',
    styleUrls: ['../../sharedStyles/base.scss'],
    templateUrl: './import-shapefile.component.html'
})

export class ImportShapefileComponent extends BaseComponent implements OnInit {

    private _enableMapFileDrop: boolean = true;

    @Input()
    get enableMapFileDrop(): boolean {
        return this._enableMapFileDrop;
    }
    set enableMapFileDrop(value: boolean) {
        this._enableMapFileDrop = BooleanConverter(value);
        if (this._enableMapFileDrop) {
            this.setDefaultDropElement();
        } else {
            this.removeMapDropEvents();
        }
    }

    @Input() dropElement: HTMLDivElement;
    @Input() mapView: IMCMapView;
    @Output() public readonly onfiledrop: EventEmitter<DragEvent> = new EventEmitter<DragEvent>();
    @Output() public readonly onfiledone: EventEmitter<DragEvent> = new EventEmitter<DragEvent>();

    constructor(
        _vcr: ViewContainerRef,
        private readonly importService: ImportService,
        protected readonly cdr: ChangeDetectorRef
    ) {
        super(_vcr, true);
        this.registerEvent('onfiledrop', this.onfiledrop);
        this.registerEvent('onfiledone', this.onfiledone);
    }

    get loading() {
        return this.importService.loading;
    }

    async ngOnInit() {
        if (this.enableMapFileDrop) {
            await this.setDefaultDropElement();
        }
        this.mapView = await this.setupMapViewRef(this.mapView);
    }

    async setDefaultDropElement() {
        if (!this.dropElement) {
            const parent = await this.getClosestAncestor('mc-map');
            if (parent) {
                await parent.ready;
                this.dropElement = parent.mapView.container;
            }
        }
        this.setupMapDropEvents();
    }

    setupMapDropEvents() {
        this.dropElement.addEventListener('dragenter', this.ondragenter);
        this.dropElement.addEventListener('drop', this.ondrop);
        this.dropElement.addEventListener('mouseover', this.hideOverlay);
        this.dropElement.addEventListener('dragend', this.hideOverlay);
        this.dropElement.addEventListener('dragleave', this.hideOverlay);
        this.dropElement.addEventListener('click', this.hideOverlay);
        this.dropElement.addEventListener('dragover', this.ondragover);
    }

    removeMapDropEvents() {
        this.dropElement.removeEventListener('dragenter', this.ondragenter);
        this.dropElement.removeEventListener('drop', this.ondrop);
        this.dropElement.removeEventListener('mouseover', this.hideOverlay);
        this.dropElement.removeEventListener('dragend', this.hideOverlay);
        this.dropElement.removeEventListener('dragleave', this.hideOverlay);
        this.dropElement.removeEventListener('click', this.hideOverlay);
        this.dropElement.removeEventListener('dragover', this.ondragover);
    }

    ondragenter = (e: DragEvent) => {
        const shapefiles = Array.from(e.dataTransfer.items).filter(x => x.type === 'application/x-zip-compressed');
        if (shapefiles.length) {
            e.preventDefault();
            this.showMapDropOverlay(true);
        }
    }

    ondragover = (e: DragEvent) => {
        e.preventDefault();
    }

    ondrop = async (e: DragEvent) => {
        e.preventDefault();
        this.showMapDropOverlay(false);
        this.onfiledrop.emit(e);
        await this.importService.importFiles(e);
        this.onfiledone.emit(e);
    }

    hideOverlay = () => {
        this.showMapDropOverlay(false);
    }

    showMapDropOverlay(show: boolean = true) {
        this.dropElement.style.setProperty('opacity', show ? '0.7' : '1');
    }

}
